import React, { useCallback } from 'react'
import { Card, CardContent, Grid, IconButton, Typography, makeStyles } from '@material-ui/core'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { GRAY_COLORS } from 'asterX-UI'
import { getValidDate } from 'lib/utils'

const useStyles = makeStyles(() => ({
  // те же ключи и значения, что и в FileContract
  wrapper: {
    marginTop: 16
  },
  contentCard: {
    marginTop: 16
  },

  // локальные классы для верстки карточки
  cardContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12
  },
  fileTextWrap: {
    flex: 1,
    minWidth: 0
  },
  fileName: {
    fontSize: 14,
    fontWeight: 600,
    wordBreak: 'break-word',
    marginBottom:'5px'
  },
  meta: {
    display: 'block',
    opacity: 0.7
  },

  card: {
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`
  },
  fileIconWrap: {
    position: 'relative'
  },
  blueLines: {
    position: 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  iconBtn: {
    margin: 0,
    padding: 8
  },
  actionBtn: {
    color: GRAY_COLORS[600]
  }
}))

export const ApplicationDocuments = ({ files = [] }) => {
  const classes = useStyles()

  // Хук объявлен до раннего return — ошибки ESLint больше не будет
  const handleDownload = useCallback((url) => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }, [])

  if (!files.length) {
    return <Typography variant="body2" className={classes.wrapper}>Документов нет</Typography>
  }

  return (
    <Grid container spacing={2} className={classes.contentCard}>
      {files.map(f => (
        <Grid item xs={12} md={6} lg={4} key={f.workListFileId}>
          <Grid item className={classes.fileName}>
            {f?.fileTypeName}
          </Grid>
          <Card variant="outlined" className={classes.card}>
            <CardContent className={classes.cardContent}>
              <div className={classes.fileIconWrap}>
                <FileIcon />
                <div className={classes.blueLines}>
                  <BlueLines />
                </div>
              </div>

              <div className={classes.fileTextWrap}>
                <Typography variant="body2" className={classes.fileName}>
                  {f.fileName}
                </Typography>
                <Typography variant="caption" className={classes.meta}>
                  Тип: {f.fileTypeCode || '-'}
                </Typography>
                <Typography variant="caption" className={classes.meta}>
                  Дата: {getValidDate(f.createdAt, true)}
                </Typography>
              </div>

              <IconButton className={classes.iconBtn} onClick={() => handleDownload(f.downloadUrl)} title="Скачать">
                <DownloadIcon className={classes.actionBtn} />
              </IconButton>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
